window.arClientFormatter = function(value, row) {
    let html = '';
    html += '<a href="/ar/relations/show/'+row.client_id+'">';
    html += value;
    html += '</a>';
    return html;
}
